import { AppBar, Dialog, DialogContent, IconButton, Toolbar, Typography, makeStyles } from '@material-ui/core'
import React from 'react'
import { RecetasDigitalesIngresoHome } from '../../recetasDigitales/Ingreso/RecetasDigitalesIngresoHome'
import { Close } from '@material-ui/icons'


const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
}));


export const ModalRecetasHCE = (props) => {
  const { hce } = props;

  const classes = useStyles();

  console.log("hce", hce)
  return (
    <Dialog fullScreen maxWidth="xl" open={props.open}>
      <AppBar className={classes.appBar}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={props.close}
            aria-label="close"
          >
            <Close />
          </IconButton>
          <Typography variant="h6" >
            Ingreso Receta
          </Typography>
        </Toolbar>
      </AppBar>
      <DialogContent>
        <RecetasDigitalesIngresoHome fromGestion={true} obraSocial={hce.idObraSocial}/>
      </DialogContent>
    </Dialog>

  )
}
